import { getCookieByName } from 'utils/getCookieByName';
const SESSION_ID_COOKIE_NAME = 'wikia_session_id';
const getSessionId = () => getCookieByName(SESSION_ID_COOKIE_NAME);
export default getSessionId;
